import MlQueries from "../MlQueries";

 
interface KycKubProps {
  tenantId: string;
  tenantServiceId: string;
  tenantServiceOptionId: string;
}

export const KycKub = ({
  tenantId,
  tenantServiceId,
  tenantServiceOptionId,
}: KycKubProps) => {
  return (
    <MlQueries
      tenantId={tenantId}
      tenantServiceId={tenantServiceId}
      tenantServiceOptionId={tenantServiceOptionId}
      category="KYB"
      title="KYC & KYB"
    />
  );
};

export default KycKub;
